import { apiClient } from './client';
import {AxiosResponse} from 'axios';
import {Page} from "@/models/Page";
import {array} from "yup";

const baseUrl = "country"

export const searchByName = (query: string) => {
    return apiClient.get(`${baseUrl}/search/findByNameContaining?name=${query.toLowerCase()}`);
}
export const searchByIds = (ids: string[]) => {
    if(ids == null || ids.length < 0) {
        return new Promise((resolve) => {resolve([])})
    }

    if(typeof ids  !== "string"){
        ids = ids.join(',')
    }

    return apiClient.get(`${baseUrl}/search/findByIds?ids=${ids}`)
}
